import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.enabled)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
}